import axios from "axios";
import { Promise } from "q";
import { API_URL, STATUS_OK } from "./../../config";

export default class BoardService {
    loadUsersShared;
    static loadUsersShared = (username, token) => {
        return new Promise((resolve, reject) => {
            axios
                .get(`${API_URL}users/${username}/shares`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(response => {
                    if (response.status === STATUS_OK) resolve(response.data);
                    else reject(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };
    static loadBookmarks = (username, token) => {
        return new Promise((resolve, reject) => {
            axios
                .get(`${API_URL}users/${username}/bookmarks`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(response => {
                    if (response.status === STATUS_OK) resolve(response.data);
                    else reject(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };
    static deleteBookmark = (id, username, token) => {
        return new Promise((resolve, reject) => {
            axios
                .delete(`${API_URL}users/${username}/bookmarks/${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                })
                .then(response => {
                    if (response.status === STATUS_OK) resolve(response.data);
                    else reject(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };
    static search = (searchText, bookmarks) => {
        return new Promise((resolve, reject) => {
            // axios
            //     .get(API_URL + "bookmarks/search", {
            //         params: {
            //             q: searchText
            //         }
            //     })
            //     .then(response => {
            //         if (response.status === STATUS_OK) resolve(response.data);
            //         else reject(response);
            //     })
            //     .catch(error => {
            //         reject(error);
            //     });
            let filteredBookmarks = {};

            if (bookmarks && bookmarks.my_bookmarks) {
                let newMyBookmarks = bookmarks.my_bookmarks.filter(
                    bookmark =>
                        bookmark.price.toString().includes(searchText) ||
                        bookmark.address.includes(searchText) ||
                        bookmark.title.includes(searchText) ||
                        bookmark.description.includes(searchText) ||
                        bookmark.url.includes(searchText)
                );
                filteredBookmarks.my_bookmarks = newMyBookmarks;
            }

            if (bookmarks && bookmarks.shared) {
                filteredBookmarks.shared = [];
                for (const share of bookmarks.shared) {
                    let clonedShare = Object.assign({}, share);
                    let filtered = share.bookmarks.filter(
                        bookmark =>
                            bookmark.price.toString().includes(searchText) ||
                            bookmark.address.includes(searchText) ||
                            bookmark.title.includes(searchText) ||
                            bookmark.description.includes(searchText) ||
                            bookmark.url.includes(searchText)
                    );
                    clonedShare.bookmarks = filtered;
                    filteredBookmarks.shared.push(clonedShare);
                }
            }

            resolve(filteredBookmarks);
        });
    };
}
